import { render, staticRenderFns } from "./PressScrapCostComponent.vue?vue&type=template&id=55a509b4&"
import script from "./PressScrapCostComponent.vue?vue&type=script&lang=js&"
export * from "./PressScrapCostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports